module.exports = __webpack_public_path__ + "img/Anna_W_Circle.230dec58.png";